export const apiKey = process.env.REACT_APP_API_KEY || "not-a-real-api-key";
